import { useState } from "react"
import { Dropdown, DropdownItem, DropdownMenu, DropdownToggle } from "reactstrap"
import styles from "./DynamicDropdown.module.scss"

const DynamicDropdown = ({ placeholder = "Select an option", options = [] }) => {
  const [dropdownOpen, setDropdownOpen] = useState(false)
  const [selectedOption, setSelectedOption] = useState(null)

  const toggle = () => setDropdownOpen((prev) => !prev)

  const handleSelect = (label, action, disabled) => {
    if (!disabled) {
      setSelectedOption(label)
      action?.()
    }
  }

  return (
    <Dropdown isOpen={dropdownOpen} toggle={toggle} className={styles.actionDropdown}>
      <DropdownToggle caret className={`w-100 d-flex justify-content-between align-items-center ${styles.dropdownButton} ${dropdownOpen && styles.open}`}>
        {selectedOption || placeholder}
      </DropdownToggle>
      <DropdownMenu className={`w-100 ${styles.dropDownMenu}`}>
        {options.length ? (
          options.map(({ label, action, disabled }, index) => (
            <DropdownItem
              key={index}
              className={`${styles.dropdownItem} ${disabled ? styles.disabled : ""}`}
              onClick={() => handleSelect(label, action, disabled)}
              disabled={disabled}
            >
              {label}
            </DropdownItem>
          ))
        ) : (
          <DropdownItem className={styles.dropdownItem} disabled>
            No options
          </DropdownItem>
        )}
      </DropdownMenu>
    </Dropdown>
  )
}

export default DynamicDropdown
